export const computeAbsolutePath = (baseURL, relURL) => {
  let http = ""
  let url = baseURL
  if (url.endsWith("/")) {
    url = url.slice(0, url.length - 1)
  }
  if (url.startsWith("https://")) {
    http = "https://"
    url = url.slice(8)
  } else if (url.startsWith("http://")) {
    http = "http://"
    url = url.slice(7)
  }
  const st = url.split("/")
  const domainSite = st[0]
  // case of direct URI
  if (relURL.startsWith("/")) {
    // relative path with domain root
    return http + domainSite + relURL
  }
  const arr = relURL.split("/")
  if (st.length > 1) {
    // keep at least domain root
    st.pop()
  }
  // ignore the current file name (or no string)
  // (ignore if "base" is the current folder without having slash in trail)
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === ".") {
      // eslint-disable-next-line no-continue
      continue
    }
    if (arr[i] === ".." && st.length === 1) {
      // eslint-disable-next-line no-continue
      continue
    }
    if (arr[i] === "..") {
      // keep at least domain root
      st.pop()
    } else {
      st.push(arr[i])
    }
  }
  return http + st.join("/")
}

export const retrieveUrlForIFrame = () => {
  // url from parent if inside iframe
  const locationAreDistinct = window.location !== window.parent.location
  let parentOrigin = (
    (locationAreDistinct ? document.referrer : document.location) || ""
  ).toString()
  if (parentOrigin === "") {
    parentOrigin = document.location.toString()
  }
  return parentOrigin
}

export const computeCompleteURLForIFrame = (relativeUrl) => {
  const parentOrigin = retrieveUrlForIFrame()
  return computeAbsolutePath(parentOrigin, relativeUrl)
}

export const completeUrlForHrefLink = (htmlText) => {
  if (typeof htmlText !== "string") {
    return htmlText
  }
  if (htmlText.includes('href="') === false) {
    return htmlText
  }
  const firstSplit = htmlText.split('href="', 2)
  const hrefUrl = firstSplit[1].slice(0, firstSplit[1].indexOf('"'))
  if (hrefUrl.startsWith("http")) {
    return htmlText
  }
  const otherHtml = firstSplit[1].slice(firstSplit[1].indexOf('"') + 1)
  const newUrl = computeCompleteURLForIFrame(hrefUrl)
  return `${firstSplit[0]}href="${newUrl}"${otherHtml}`
}
